import { defineStore } from "pinia";
import Router from './../routes';
import Http from '../utils/http';
import Utils from '../utils/utils';
import i18n from '../localizations';
import { useRootStore } from "./root";

export const useUsersStore = defineStore("users", {
    state: () => ({
        users: [],
        roles: [],
        editedUser: {}
    }),

    actions: {
        setUsers(users) {
            this.users = [];
            
            users.forEach(user => this.users.push({
                id: user['id'],
                fullName: `${user['first_name']} ${user['last_name']}`,
                email: user['email'],
                avatar: user['avatar'],
                role: user['role'] ? user['role']['key'] : ''
            }));
        },

        setRoles(roles) {
            this.roles = roles;
        },

        setEditedUser(user) {
            let roleId = 0;
            let roleName = '';

            if (user['role']) {
                roleId = user['role']['id'];
                roleName = user['role']['name'];
            }

            this.editedUser = {
                id: user['id'],
                firstName: user['first_name'],
                lastName: user['last_name'],
                email: user['email'],
                role: {
                    id: roleId,
                    name: roleName
                }
            }
        },
        
        loadUsers() {
            Http.get('/api/users')
                .then(response => {
                    const users = response.data || [];
                    this.setUsers(users);
                })
                .catch(error => console.error(error));
        },

        loadUser(userId) {
            Http.get(`/api/users/${userId}`)
                .then(response => {
                    const user = response.data;
                    this.setEditedUser(user);
                })
                .catch(error => console.error(error));
        },

        loadRoles() {
            Http.get('/api/roles')
                .then(response => {
                    const roles = response.data || [];
                    this.setRoles(roles);
                })
                .catch(error => console.error(error));
        },

        createUser(payload) {
            const rootStore = useRootStore();
            
            Http.post('/api/users', payload)
                .then(response => {
                    const user = response.data;
                    const notification = Utils.createNotification(
                        'success',
                        i18n.t('notifications.user_successfully_created', { userName: user['full_name'] })
                    );
                    
                    rootStore.clearNotifications();
                    rootStore.pushNotification(notification);

                    Router.push('/users', null);
                })
                .catch(error => Utils.resolveValidationErrors(error));
        },

        updateUser(user) {
            const userId = user.id;

            if (user.id !== undefined)
                delete user.id;
            
            const rootStore = useRootStore();

            Http.put(`/api/users/${userId}`, user)
                .then(response => {
                    const user = response.data;
                    const notification = Utils.createNotification(
                        'success',
                        i18n.t('notifications.user_successfully_edited', { userName: user['full_name']})
                    );

                    rootStore.clearNotifications();
                    rootStore.pushNotification(notification);

                    Router.push('/users', null);
                })
                .catch(error => Utils.resolveValidationErrors(error))
        },

        deleteUser(userId) {
            const rootStore = useRootStore();
            
            Http.delete(`/api/users/${userId}`)
                .then(response => {
                    const user = response.data;

                    const notification = Utils.createNotification(
                        'success',
                        i18n.t('notifications.user_successfully_deleted', { userName: user['full_name'] })
                    );

                    rootStore.clearNotifications();
                    rootStore.pushNotification(notification);

                    this.loadUsers();
                })
                .catch(error => {
                    if (error.response.status === 400) {
                        const notification = Utils.createNotification(
                            'danger',
                            i18n.t('notifications.can_not_delete_yourself')
                        );

                        rootStore.clearNotifications();
                        rootStore.pushNotification(notification);
                    } else
                        console.error(error.response);
                });
        },

        clearState() {
            this.$reset();
        },
    }
})